import React from 'react'
import { Box, DataListItem, Tooltip } from '@node-space/ui-components'

export interface SidePanelRowProps {
  label: string
  content: string
  copyText?: string
  tooltip?: string
}

export interface SidePanelSummaryProps {
  rows: SidePanelRowProps[]
  showEmpty?: boolean
}

export const SidePanelSummary = ({ rows, showEmpty }: SidePanelSummaryProps) => {
  return (
    <Box tag="table">
      <Box tag="tbody">
        {rows
          ?.filter(({ content }) => showEmpty || !!content)
          ?.map(({ label, content, copyText, tooltip }) => (
            <DataListItem
              key={label}
              id={label}
              title={label}
              body={content}
              {...(!!copyText && { copyText })}
              {...(!!tooltip && {
                Tooltip: <Tooltip bodyContent={tooltip} type="complex" />,
              })}
            />
          ))}
      </Box>
    </Box>
  )
}
